import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$window, $body} from '../Constants';

/**
 * Videos
 */
class Videos extends HtmlElement {
    onReady() {
        this.$videos = this.$element.find('.videos-video');
        this.players = [];
        this.videoWidth = '100%';
        this.videoHeight = '400';
        this.active = 1;

        YT.ready(() => {
            this.players = this.initPlayers();
            this.changeVideo(this.active);
        });

        this.bindHandlers();
    }

    onResize() {
        this.setVideosContentHeight(this.getActiveVideo().height());
    }

    initPlayers() {
        let _self = this,
            players = [],
            player = null;

        this.$videos.each(function() {
            let $video = $(this);

            player = new YT.Player($video.find('.videos-video-iframe').attr('id'), {
                width: _self.videoWidth,
                height: _self.videoHeight,
                videoId: $video.data('id')
            });

            players.push(player);
        });

        return players;
    }

    bindHandlers() {
        let _self = this;

        this.$element.find('.videos-nav li').stop(true, false).on('click', function() {
            _self.pauseVideos();
            _self.changeVideo($(this).data('video'));
        });
    }

    changeVideo(id) {
        this.setNavActive(id);

        this.$element.find('#videos-video-' + this.active).fadeOut(300, () => {
            this.$element.find('#videos-video-' + id).fadeIn(400);
            this.active = id;

            this.setVideosContentHeight(this.getActiveVideo().height());
        });
    }

    getActiveVideo() {
        return this.$element.find('#videos-video-' + this.active);
    }

    getPlayerOfVideo($video) {
        return YT.get($video.find('.videos-video-iframe').attr('id'));
    }

    setNavActive(id) {
        this.$element.find('.videos-nav li').removeClass('act');
        this.$element.find('.videos-nav li[data-video="' + id + '"]').addClass('act');
    }

    setVideosContentHeight(height) {
        this.$element.find('.videos-content').css('height', height);
    }

    pauseVideos() {
        for(let i = 0; i < this.players.length; i++) {
            if(this.players[i].getPlayerState() == YT.PlayerState.PLAYING) {
                this.players[i].pauseVideo();
            }
        }
    }
}

export default (new Videos($body.find('.videos')));